<div class="px64SS">
    <div class="lineCustom"></div>
  
    <div class="fixFlexConsents">
      <div style="width: 90%">
        <button nxPlainButton type="button">
          <span class="readMore">
            {{ "consent.popUpDataMarketing" | translate }}
          </span>
        </button>
      </div>
      <div class="width10end">
        <button nxPlainButton type="button" (click)="readMore('B1')">
          <nx-icon
            name="chevron-up"
            class="nx-margin-right-xs fileTextIcon"
            *ngIf="trigger1 == true"
          ></nx-icon>
          <nx-icon
            name="chevron-down"
            class="nx-margin-right-xs fileTextIcon"
            *ngIf="trigger1 !== true"
          ></nx-icon>
        </button>
      </div>
    </div>
    <div *ngIf="trigger1 == true" class="formatProducts">
        <div>
            <p class="textBig">{{data.popUpDataMarketing1 | translate}}</p>
        </div>
        <div class="secondPart">
            <button nxPlainButton type="button">
                <p class="pStyle"> <nx-icon name="pdf" size="s"> </nx-icon><span [innerHtml]="'consent.popUpDataMarketing2PDF' | translate | safeHtml"></span></p>
            </button>
        </div>
    </div>
  
    <div class="lineCustom"></div>
  
    <div class="fixFlexConsents">
      <div style="width: 90%">
        <button nxPlainButton type="button">
          <span class="readMore">{{ "consent.productDetails" | translate }}</span>
        </button>
      </div>
      <div class="width10end">
        <button nxPlainButton type="button" (click)="readMore('B2')">
          <nx-icon
            name="chevron-up"
            class="nx-margin-right-xs fileTextIcon"
            *ngIf="trigger2 == true"
          ></nx-icon>
          <nx-icon
            name="chevron-down"
            class="nx-margin-right-xs fileTextIcon"
            *ngIf="trigger2 !== true"
          ></nx-icon>
        </button>
      </div>
    </div>
    <div *ngIf="trigger2 == true" class="formatProducts">
        <div>
            <p class="textBig">{{data.productDetails1 | translate}}</p>
        </div>
        <div class="secondPart">
            <button nxPlainButton type="button">
                <p class="pStyle"> <nx-icon name="pdf" size="s"></nx-icon> <span [innerHtml]="'consent.productDetails2PDF' | translate | safeHtml"></span></p>
            </button>
            <button nxPlainButton type="button">
                <p class="pStyle"> <nx-icon name="pdf" size="s"></nx-icon> <span [innerHtml]="'consent.productDetails3PDF' | translate | safeHtml"></span></p>
            </button>
            <button nxPlainButton type="button">
                <p class="pStyle"> <nx-icon name="pdf" size="s"></nx-icon> <span [innerHtml]="'consent.productDetails4PDF' | translate | safeHtml"></span></p>
            </button>
            <button nxPlainButton type="button" *ngIf="!(data.hasRegistration )">
              <p class="pStyle"> <nx-icon name="pdf" size="s"></nx-icon> <span [innerHtml]="'consent.productDetails6PDF' | translate | safeHtml"></span></p>
          </button>
            <button nxPlainButton type="button">
                <p class="pStyle"> <nx-icon name="pdf" size="s"></nx-icon> <span [innerHtml]="'consent.productDetails5PDF' | translate | safeHtml"></span></p>
            </button>
        </div>
    </div>
      <div class="lineCustom" *ngIf="trigger2 !== true"></div>
  </div>
  